const { h, render, Component } = require('preact');
const GrouponValidate = require ("../../../groupon/frontend/validate")

class UserContact extends Component {
  constructor(props) {
    super(props);
    this.onContactOnlyByMail = this.onContactOnlyByMail.bind(this)
    this.changeUserContactInfoState = this.changeUserContactInfoState.bind(this)
    this.validateContactPhone = this.validateContactPhone.bind(this)
    this.populateInput = this.populateInput.bind(this)
    this.isInputValid = this.isInputValid.bind(this)
    this.isInputGiven = this.isInputGiven.bind(this)
  }

  changeDescriptionText() {
    var elemText = document.createTextNode(I18n.translate('js.modules.support.additional_details_example'));
    document.getElementbyId('ticket_description').appendChild(elemText)
  }

  contactOnlyByMail() {
    return document.getElementById('contactOnlyByMail').checked
  }

  getUserPhoneElement() {
    return document.getElementById('contact_phone')
  }

  getUserLoggedIn() {
    return JSON.parse(Groupon.Utils.getConfigFromDom().user);
  }

  getUserEmailElement() {
    return document.getElementById('contact_email')
  }

  changeUserContactInfoState () {
    this.props.updateState(this.props.attrs.type, this.props.attrs.counter, this.populateInput(), this.isInputValid())
  }

  validateContactEmail() {
    var email_id = this.getUserEmailElement().value.trim()
    if (GrouponValidate.email(email_id)) {
      document.getElementById('validateContactEmail').style.display = 'none'
      return true
    }
    else {
      document.getElementById('validateContactEmail').style.display = 'block'
      return false
    }
  }

  validateContactPhone() {
    var phoneNum = this.getUserPhoneElement().value.trim()
    if (GrouponValidate.phone(phoneNum)) {
      document.getElementById('validateContactPhone').style.display = 'none'
      return true
    }
    else {
      document.getElementById('validateContactPhone').style.display = 'block'
      return false
    }
  }

  populateInput() {
    let data = {
      user_given_email: this.getUserEmailElement().value.trim(),
      user_given_phone: this.getUserPhoneElement().value.trim(),
      contact_only_email: this.contactOnlyByMail(),
      userContactInfoView: true
    }
    return data
  }

  isInputValid() {
    if (this.contactOnlyByMail()) {
      return this.validateContactEmail()
    }
    else
      return this.validateContactPhone()
  }

  isInputGiven() {
    if (this.contactOnlyByMail()) {
      return this.getUserEmailElement().value.trim().length > 0
    }
    else
      return this.getUserPhoneElement().value.trim().length > 0
  }


  onContactOnlyByMail() {
    document.getElementById('validateContactPhone').style.display = 'none'
    if (this.contactOnlyByMail()) {
      this.getUserPhoneElement().setAttribute('disabled', 'disabled')
      this.getUserPhoneElement().value = ''
      this.getUserEmailElement().style.display = 'block'
      if (this.getUserLoggedIn()) {
        this.getUserEmailElement().value = this.getUserLoggedIn().email
      }
      else {
        this.getUserEmailElement().value = document.getElementById('tcktUsermail').value
        document.getElementsByClassName(".stepThreeLabel contactOnlyByPhonenumberMandatory").style.display = 'none'
        document.getElementById("contactOnlyByMailMandatory").style.display = 'inline'
        document.getElementsByClassName(".inputField contact_phone").value = ''
      }
    }
    else
    {
      this.getUserPhoneElement().removeAttribute('disabled')
      this.getUserEmailElement().style.display = 'none'
      document.getElementById('validateContactEmail').style.display = 'none'
      document.getElementById("contactOnlyByMailMandatory").style.display = 'none'
      document.getElementById("contactOnlyByPhonenumberMandatory").style.display = 'inline'
      document.getElementById("contact_email").value = ''
    }
  }

  componentDidMount() {
    var userContactInfo = document.getElementById("contact_phone")
    userContactInfo.addEventListener("keyup", this.changeUserContactInfoState)

    var contactOnlyByMailCheckBox = document.getElementById("contactOnlyByMail");
    contactOnlyByMailCheckBox.addEventListener("change", this.onContactOnlyByMail)

    var contactEmailBox = document.getElementById("contact_email")
    contactEmailBox.addEventListener("keyup", this.changeUserContactInfoState)
  }

  render() {
    return (
      <div>
        <div class="requestedFields mb40">
          <label class="stepThreeLabel">
              <strong>{I18n.translate('js.modules.support.user_phone')}</strong>
              <span class="mandatory-field" id="contactOnlyByPhonenumberMandatory">* </span>
          </label>
          {I18n.translate('js.modules.support.solutionhint')}<br/>
          <input class="inputField" id ="contact_phone" maxLength="250" type="text" name="contactPhone"
          placeholder="( ___ ) ___ - ____" aria-label="Phone Number"/><br/>

          <span id="validateContactPhone" class="invalid-input initially-hidden error">
              {I18n.translate('js.modules.support.invalidphone')}
          </span>
          <label for="contactOnlyByMail">
            <input type="checkbox" id="contactOnlyByMail" name="onlymail" value="" data-bhw="ContactViaEmail" aria-label="Contact by Email"/>
            {I18n.translate('js.modules.support.contactbymailonly')}
            <span class="mandatory-field" id="contactOnlyByMailMandatory" style = "display:none;">* </span>
          </label>
          <input class="inputField initially-hidden" id ="contact_email" style = "display:none" size="40" maxLength="250" type="text" name="contactEmail" aria-label="Email Address"/>
          <span id="validateContactEmail" class="invalid-input error initially-hidden">
          {I18n.translate('js.modules.support.invalidemail')}
          </span>
        </div>
      </div>
    )
  }
}

module.exports = UserContact
